
export function comprovanteDespesasLiberamNovaSolicitacao(
  value: boolean | null | undefined,
): boolean {
  return value === true;
}


export function pickComprovanteDespesasAssinadoListItem(
  item: Record<string, unknown> | null | undefined,
): boolean {
  if (!item) return false;
  const v =
    item.comprovanteDespesasAssinado ??
    (item as { ComprovanteDespesasAssinado?: boolean })
      .ComprovanteDespesasAssinado ??
    (item as { comprovanteDespesaAssinado?: boolean })
      .comprovanteDespesaAssinado;
  if (v === true) return true;
  if (v === false) return false;
  return false;
}
